import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum CustomerWidgetDataTarget {
  CHIPS_WRAPPER = "supp-chips-wrapper",
  CHIP_TEXT = "supp-chip-text",
  CHIP = "supp-chip",
  CHIPS_CLOSE_BUTTON = "supp-chips-close-button",
  CHAT_BUBBLE_TEXT = "supp-chat-bubble-text",
  CHAT_BUBBLE = "supp-chat-bubble",
  CHAT_BUBBLE_CLOSE_BUTTON = "supp-chat-bubble-close-button",
}

export enum PredefinedChipOptions {
  FIND_ORDER = "FIND_ORDER",
  RECOMMENDATIONS = "RECOMMENDATIONS",
  POPULAR_ITEM = "POPULAR_ITEM",
  BEST_SELLERS = "BEST_SELLERS",
}

// Worded as coming from the merchant to the customer
export const predefinedChipOptionsToTextMap: Record<
  PredefinedChipOptions,
  string
> = {
  [PredefinedChipOptions.FIND_ORDER]: "Can I help you find your order?",
  [PredefinedChipOptions.RECOMMENDATIONS]: "Want recommendations?",
  [PredefinedChipOptions.POPULAR_ITEM]: "Check out our most popular item",
  [PredefinedChipOptions.BEST_SELLERS]: "Check out our best sellers",
};

// Worded as coming from the customer to the merchant
export const customerChipOptionsToTextMap: Record<
  PredefinedChipOptions,
  string
> = {
  [PredefinedChipOptions.FIND_ORDER]: "Where's my order?",
  [PredefinedChipOptions.RECOMMENDATIONS]:
    "What recommendations would you make?",
  [PredefinedChipOptions.POPULAR_ITEM]: "What's the most popular item?",
  [PredefinedChipOptions.BEST_SELLERS]: "Show me the best sellers",
};

export const chipsSettingsSchema = z.object({
  selectedPredefinedChips: z.array(
    createEnum(PredefinedChipOptions, { enumName: "PredefinedChipOptions" }),
  ),
  customChips: z.array(z.string().min(1)),
});

export type ChipsSettings = z.infer<typeof chipsSettingsSchema>;

export function isPredefinedChipOption(
  value: string,
): value is PredefinedChipOptions {
  return Object.values(PredefinedChipOptions).includes(
    value as PredefinedChipOptions,
  );
}

export enum CustomerWidgetState {
  HOME = "home",
  CONVERSATIONS_LIST = "conversations",
  SUPPORT_MESSAGING = "messaging",
  ORDERS = "orders",
  ORDER_DETAILS = "order-details",
  ACCOUNT = "account",
  CONCIERGE_MESSAGING = "concierge-messaging",
  WISH_LIST = "wish-list",
  CONCIERGE_EMAIL_SIGN_UP = "concierge-email-sign-up",
}

export type GetCustomerWidgetStateFn = () => CustomerWidgetState;
